import axios from 'axios'
import { getState } from 'store/configureStore'

const baseURL = process.env.REACT_APP_HOST + '/api'

const apiMultipart = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
})

const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
})

export const invokeApi = ({
  url,
  method = 'get',
  data = {},
  type = 'cms:json',
  params = {},
  headers,
}) => {
  if (!headers) {
    const { token, ucn } = getState().auth
    headers = { token, ucn }
  }

  switch (type) {
    case 'cms:multipart':
      return apiMultipart({ url, method, data, headers, params })
    case 'api:json':
    case 'cms:json':
    default:
      return api({ url, method, data, headers, params })
  }
}
